// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "html body[data-v-7ba5bd90] {\n  font-family: \"MicrosoftYahei\";\n}\n", "",{"version":3,"sources":["C:/work/takeda/ui/takeda_front/src/C:/work/takeda/ui/takeda_front/src/App.vue"],"names":[],"mappings":"AACA;EACE,6BAA6B;AAAA","file":"App.vue","sourcesContent":["\r\nhtml body {\r\n  font-family: \"MicrosoftYahei\";\r\n}\r\n"]}]);
// Exports
module.exports = exports;
